// extracted by mini-css-extract-plugin
export default {"mainContainer":"SilencingPage_mainContainer__OLl7l","silencingPage":"SilencingPage_silencingPage__Mi60-"};